module.exports = __webpack_public_path__ + "img/img3.a4cc9728.png";